export class OriginalMessage{
    language:string;
    subject:string;
    content:string;

}